import dynamic from 'next/dynamic'

export const DynamicSnapEBTCardVerificationModal = dynamic(
  () => import('.').then((mod) => mod.SnapEBTCardVerificationModal),
  { ssr: false },
)
